




















































































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserAvatar from '@/modules/shared/components/UserAvatar'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import {
  ConfirmTournamentTeamRosterRequest,
  TournamentAPI
} from '@/api/tournament'
import {
  TournamentPlayerEntity,
  TournamentTeamEntity
} from '@/api/tournamentTeam'
import { TournamentTeamPostAPI } from '@/api/tournamentTeamPost'

@Component({
  components: {
    UserAvatar
  }
})
export default class TeamLFGManagement extends Vue {
  @Prop({ required: true }) tournamentTeamId!: string
  @PropSync('visible', { default: false }) isVisible!: boolean
  userModule = getModule(userStore, this.$store)
  isProcessing: boolean = false
  tournamentTeam: TournamentTeamEntity | null = null

  @Watch('isVisible')
  async onVisibilityChanged(visible: boolean) {
    if (visible) {
      await this.fetchData()
    }
  }

  @Watch('tournamentTeam')
  async onRosterChanged(tournamentTeam: TournamentTeamEntity) {
    this.refreshSelectedRoster()
  }

  /* Vuex State */
  get userId() {
    return this.userModule.userId
  }

  /* Computed Properties */

  /* Methods */
  async fetchData() {
    this.tournamentTeam = null

    try {
      const res = await TournamentAPI.getTournamentTeam(this.tournamentTeamId)
      let payload = res.data.payload
      if (payload) {
        this.tournamentTeam = payload
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      }

      console.error(err)
    }
  }

  refreshSelectedRoster() {
    if (!this.tournamentTeam) {
    }
  }

  get players() {
    if (!this.tournamentTeam) return []

    return this.tournamentTeam.players.filter(
      player => player.role === 'RequestToJoin'
    )
  }

  async approveMember(memberId: string) {
    if (!memberId) return

    try {
      this.isProcessing = true
      const res = await TournamentTeamPostAPI.acceptJoinRequest(
        this.tournamentTeamId,
        memberId
      )
      if (res.data.status) {
        this.$toast.success(this.$t('TeamLFGManagement.ApprovedMessage'))
        await this.fetchData()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      }
      console.error(err)
    } finally {
      this.isProcessing = false
    }
  }

  async rejectMember(memberId: string) {
    if (!memberId) return

    try {
      this.isProcessing = true
      const res = await TournamentAPI.removeTeamMember(
        this.tournamentTeamId,
        memberId
      )
      if (res.data.status) {
        this.$toast.error(this.$t('TeamLFGManagement.RejectedMessage'))
        await this.fetchData()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      }
      console.error(err)
    } finally {
      this.isProcessing = false
    }
  }
}
